export default "__VITE_ASSET__Bntsadzv__"